export default __webpack_public_path__ + "7553aaffb738da0154aea7503007be8e.png";